<template>
  <table v-table-resizer class="table table-striped">
    <thead>
      <tr>
        <th class="fandom">Fandom</th>
        <th class="prompts">Requests</th>
      </tr>
    </thead>
    <tbody v-if="filtered.length">
      <tr v-for="group in filtered" :key="group.fandom">
        <td class="fandom" data-label="Fandom">
          <router-link class="text-bold" :to="`/everything/fandom/${group.fandom}`">{{
            group.fandom
            }}</router-link>&nbsp;
        </td>
        <td class="prompts">
          <button class="btn btn-sm" @click="toggleFandom(group.fandom)">
            <span v-if="shouldShowFandom(group.fandom)">Collapse prompts </span>
            <span v-else>Expand prompts </span>
          </button>

          <template v-if="shouldShowFandom(group.fandom)">
            <div v-for="prompt in group.prompts" :key="prompt.sha" class="prompt">
              <div class="user-data">
                <strong>
                  <button aria-label="Toggle prompt bookmark" v-if="!isExchangeOpen(prompt.exchange)" class="bookmark"
                    @click="toggleEverythingBookmark(prompt)">
                    <span aria-label="Remove bookmark" v-if="hasEverythingBookmark(prompt)" class="fas fa-heart"></span>
                    <span v-else class="far fa-heart" aria-label="Bookmark"></span>
                  </button>
                  <router-link :to="`/${prompt.exchange}`">{{ prompt.exchange }}</router-link>
                </strong>
              </div>

              <!-- <div class="flex"> -->

              <div :class="[options.charsAsTags ? '' : 'flex']">
                <character-list v-if="(prompt.characters && prompt.characters.length) || (prompt.relationships &&
                  prompt.relationships.length)" :characters="prompt.characters"
                  :relationships="prompt.relationships" :tags="options.charsAsTags">
                </character-list>

                <!-- <div class="requested-characters">
                  <strong>Characters & Relationships &nbsp;</strong>
                  <template v-if="prompt.relationships">
                    <ul class="characters mt-2">
                      <li v-for="(c, i) in prompt.relationships" :key="`${prompt.id}-${c}-${i}`">
                        {{ c }}
                      </li>
                    </ul>
                  </template>
<template v-if="prompt.characters && prompt.characters.length">
                    <hr v-if="prompt.relationships && prompt.relationships.length" class="mt-2" />
                    <ul class="characters mb-t">
                      <li v-for="(c, i) in prompt.characters" :key="`${prompt.id}-${c}-${i}`">
                        {{ c }}
                      </li>
                    </ul>
                  </template>
<div v-if="!prompt.relationships && !prompt.characters">
  None
</div>
</div> -->

                <div>
                  <div>
                    <div class="mb-2" v-if="prompt.due_date">
                      <strong>Exchange Closes Around:</strong>&nbsp;
                      <span>{{
                        exchangeDate(prompt.exchange, "due_date")
                          ? new Date(exchangeDate(prompt.exchange, "due_date")).toDateString()
                          : "--"
                      }}</span>
                    </div>
                    <chips v-if="prompt.fandoms && prompt.fandoms.length > 1"
                      :tags="prompt.fandoms.filter((f) => f != prompt.fandom)" type="fandom" :exchangeId="exchangeId"
                      title="Other Fandoms"></chips>

                    <div class="mb-2" v-if="prompt.title">
                      <strong>Title:</strong>&nbsp;
                      <span>{{ prompt.title }}</span>
                    </div>

                    <chips :tags="prompt.warnings" title="Warnings"></chips>

                    <chips :tags="prompt.ratings" title="Ratings"></chips>

                    <chips :tags="prompt.freeforms" title="Freeforms" :truncate="options.truncateTags"
                      :limit="options.tagLimit">
                    </chips>

                    <chips :tags="prompt.optional_tags" title="Optional Tags" :truncate="options.truncateTags"
                      :limit="options.tagLimit"></chips>
                  </div>
                  <div class="mb-2" v-if="prompt.letter && prompt.letter.length">
                    <a :href="prompt.letter" target="blank">Letter </a><span class="tooltip c-hand" data-tooltip="If a request has HTML links in 
the optional details but no letter, 
the scraper interprets the last link
as a letter. Alas, this cannot be 
fixed due to the nature of AO3's
request page.">
                      <sup> <i class="fa fa-exclamation-circle" aria-hidden="true"></i> </sup></span>
                  </div>

                  <button class="btn btn-sm mb-2" v-if="options.useToggles && prompt.prompt"
                    @click="togglePrompt(prompt.sha)">
                    <span v-if="shouldShowPrompt(prompt.sha)">Show less </span>
                    <span v-else>Read optional details </span>
                  </button>
                  <template v-if="(!options.useToggles || shouldShowPrompt(prompt.sha)) && prompt.prompt">
                    <div v-html="prompt.prompt" class="prompt-text"></div>
                  </template>

                  <p v-else-if="!prompt.prompt">
                    No optional details given.
                    <span v-if="prompt.letter">
                      However, they do have a
                      <a :href="prompt.letter" target="blank">letter</a>
                      <span class="tooltip c-hand" data-tooltip="If a request has HTML links in 
the optional details but no letter, 
the scraper interprets the last link
as a letter. Alas, this cannot be 
fixed due to the nature of AO3's
request page.">
                        <sup>
                          <i class="fa fa-exclamation-circle" aria-hidden="true"></i> </sup></span>.
                    </span>
                  </p>
                </div>
              </div>

              <hr class="break mt-2 mb-2" />
            </div>
          </template>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import Chips from "../components/chips.vue";
import CharacterList from "./character-list.vue";
import utils from "../components/utils.js";
import tableResizer from "../directives/tableResizer";
// third party
import { mapGetters } from "vuex";
import { includes, remove } from "lodash-es";

export default {
  name: "userFandomTable",
  directives: {
    tableResizer
  },
  components: {
    CharacterList,
    Chips
  },
  props: {
    updating: {
      type: Boolean,
      default: true
    },
    processing: {
      type: Boolean,
      default: true
    },
    filtered: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      showFandom: [],
      showPrompt: []
    };
  },
  computed: {
    ...mapGetters(["exchangeId", "bookmarks", "loaded", "options", "promptmarks", "prompts"])
  },
  methods: {
    ...utils,
    isExchangeOpen(ex) {
      if (this.exchanges) {
        var meta = find(this.exchanges, (e) => {
          return e.name == ex;
        });

        if (meta) {
          return meta.isOpen;
        }

        return false;
      }
    },
    toggleFandom(fandom) {
      if (this.shouldShowFandom(fandom)) {
        this.showFandom = remove(this.showFandom, fandom);
      } else {
        this.showFandom.push(fandom);
      }
    },
    shouldShowFandom(fandom) {
      return includes(this.showFandom, fandom);
    },
    togglePrompt(sha) {
      if (this.shouldShowPrompt(sha)) {
        this.showPrompt = remove(this.showPrompt, sha);
      } else {
        this.showPrompt.push(sha);
      }
    },
    shouldShowPrompt(sha) {
      return includes(this.showPrompt, sha);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/variables.scss";

.field-select {
  flex: 0 1 auto;
  width: 33%;
}

.prompt {
  margin: 0.8em 0;
  // border-bottom: 1px solid $outline-light;

  &:last-child {
    .break {
      display: none;
    }
  }
}

.bookmark,
.letter {
  height: 1.3em;
}

.user-data {
  font-size: larger;

  .letter {
    padding: 0;
    margin: 0;
    vertical-align: baseline;
  }

  .bookmark {
    position: relative;
    bottom: 2px;
    margin-right: 0.4em;
  }
}

.flex {
  margin-top: 0.4em;
  display: flex;
}

ul {
  li {
    margin: 0;
    padding: 4px 0;
    border-bottom: 1px solid $outline-light;

    &:last-child {
      border: 0;
    }

    &:first-child {
      padding-top: 0;
    }
  }
}

.requested-characters {
  // margin-top: 1em;
  margin-right: 1em;
  flex: 0 0 25%;
}

.toggle {
  width: 150px;
  height: 35px;
  display: block;
}

.break {
  width: 80%;
  margin: 0.8em auto;
}

@media screen and (max-width: 880px) {
  .flex {
    display: inherit;
  }

  .requested-characters {
    display: block;
    margin-bottom: 0.5em;
  }
}
</style>
